/*eslint new-cap:0 */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import ViewModel from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/search-bid';
import template from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/steps/search-bid.pug';
import getTrafficEstimation from '@bingads-webui-campaign-legacy/budget/shared/getTrafficEstimation';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import { getBidSuggestion } from '@bingads-webui-campaign-legacy/budget/shared/getBudgetBidSuggestion';
import load from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/steps/dynamic-require-es6-load';
import { isMSStoreAdsCampaign } from '@bingads-webui-campaign-react/ms-store-ads-common';
import config from '@bingads-webui-component-legacy/config/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { defaultMSStoreMinSuggestionBid } from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const bidSugggestionNewApi = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.CampaignTrafficEstimateWithSuggestedBid';

const {
  IsSuggestionInAdGroupCreationWorkflowEnabled,
  IsSuggestionInAdGroupCreationWorkflowVNextEnabled,
} = pageContext.Permissions;
const bidRange = config.get('KeywordBidRange');

export default class View extends Backbone.View {
  initialize({
    newI18n,
    showTrafficEstimation = false,
    budget = 0,
    getKeywordsCb = () => {
      return [];
    },
    adgroup,
    inputLabel = i18n.get('Bids_SearchNetworkBid_New'),
    popupId,
    languages = [],
    bidStatusEnabled = false,
    isInKeywordCreationWorkflow = false,
    isForVNext = false,
    campaign,
    activityLogger,
    AdGroupLogId,
    defaultBidValue = null,
  }) {
    this.isMSStoreAdsGAWorkflow = isMSStoreAdsCampaign(campaign);
    this.AdGroupLogId = AdGroupLogId;
    this.budget = budget;
    this.inputLabel = inputLabel;
    this.getKeywordsCb = getKeywordsCb;
    this.popupId = popupId;
    this.activityLogger = activityLogger;
    this.campaign = campaign;
    this.viewModel = new ViewModel({
      adgroup,
      isInKeywordCreationWorkflow,
      newI18n,
      campaign,
      activityLogger,
      AdGroupLogId,
      defaultBidValue,
      isMSStoreAdsGAWorkflow: this.isMSStoreAdsGAWorkflow,
    });
    const suggestionEnabled =
      (isForVNext && IsSuggestionInAdGroupCreationWorkflowVNextEnabled) ||
      (!isForVNext && IsSuggestionInAdGroupCreationWorkflowEnabled);

    this.bidStatusEnabled =
      bidStatusEnabled &&
      suggestionEnabled &&
      showTrafficEstimation;
    this.isInKeywordCreationWorkflow = isInKeywordCreationWorkflow;
    this.showTrafficEstimation = showTrafficEstimation;
    this.languages = languages;
    this.isNKW = false;
    this.viewedSuggestion = false;
    this.updatedTimestamp = 0;
    this.defaultMSStoreMinSuggestionBid = defaultMSStoreMinSuggestionBid();

    if (this.bidStatusEnabled) {
      this.statusSubscription = this.viewModel.bidStatus.subscribe(() => {
        this.closeBidPopup();
      });
    }

    this.beginEstimationDebounced = _.debounce(this.beginEstimation, 1000);
    this.fetchBidSuggestionNewApiDebounced = _.debounce(this.fetchBidSuggestionNewApi, 1000);

    return this;
  }

  get events() {
    return {
      'click .input-group .status_warning': 'raiseBidPopup',
      'click .bidlandscape_icon': 'showBidLandscape',
      'change .input-group input.searchbid': 'bidChanged',
      'keyup .input-group input.searchbid': 'bidInput',
      'click .btn-apply-bid.btn.btn-default': 'applySuggestedBid',
    };
  }

  get className() {
    return 'search-bid-view';
  }

  applySuggestedBid() {
    instrumentation.logMessage(
      [constants.LOGCATEGORY.SUBSTRATE],
      constants.LOGLEVEL.INFO,
      'apply Suggested Bid',
      JSON.stringify({
        Scenario: 'AdgroupCreation',
        SuggestedBid: this.viewModel.suggestedBidNew(),
        OriginalInputBid: this.viewModel.SearchBid(),
        EventName: 'CreationFlowLowBidSuggestionApply',
        SuggestedBidRequestId: this.viewModel.suggestedBidRequestId(),
        CampaignId: this.campaign.Id,
        AdGroupLogId: this.AdGroupLogId,
      }),
    );
    this.viewModel.SearchBid(this.viewModel.suggestedBidNew());
    this.beginEstimationDebounced();
  }

  bidChanged() {
    if (this.activityLogger) {
      this.activityLogger.signal('search bid change', 'search bid');
    }
  }

  bidInput() {
    this.validateMinSuggestionBid();
    this.beginEstimationDebounced();
    if (!this.viewModel.isBidChanged()) {
      this.viewModel.isBidChanged(true);
    }
  }
  validateMinSuggestionBid() {
    const bid = this.viewModel.SearchBid();

    this.viewModel.showLowerThanMinSuggestionBidWarning(this.isMSStoreAdsGAWorkflow && bid < this.defaultMSStoreMinSuggestionBid);
  }

  showBidLandscape(event) {
    this.trigger('bid:clicked-bid-landscape', event);
  }

  raiseBidPopup(e) {
    const self = this;

    if ($(e.target).hasClass('status_warning')) {
      const popup = $('.raise-bid-popup-container');

      // only import and render the popup at first time
      if (this.bidStatusEnabled && _.isUndefined(self.bidSuggestionView)) {
        const popupContentViewPromise = load('@bingads-webui-campaign-legacy/budget/view/bid-suggestion-popup');

        popupContentViewPromise.then(({ default: PopupContentView }) => {
          self.bidSuggestionView = new PopupContentView({
            i18n,
            suggestedBid: self.viewModel.suggestedBid(),
            el: self.$('.raise-bid-popup-container'),
            callback: () => self.viewModel.SearchBid(self.viewModel.suggestedBid()),
          }).render();
          this.viewedSuggestion = true;
        });
      }

      popup.show();
    }
  }

  closeBidPopup() {
    const popup = $('.raise-bid-popup-container');

    popup.hide();
  }

  render() {
    this.$el.append(template({
      i18n,
      accountCurrencyCode: pageContext.AccountCurrencyCode,
      showTrafficEstimation: this.showTrafficEstimation,
      inputLabel: this.inputLabel,
      popupId: this.popupId,
      bidStatusEnabled: this.bidStatusEnabled,
      isInKeywordCreationWorkflow: this.isInKeywordCreationWorkflow,
      defaultMSStoreMinSuggestionBid: this.defaultMSStoreMinSuggestionBid,
    }));
    ko.applyBindings(this.viewModel, this.el);
    this.validateMinSuggestionBid();
    return this;
  }

  beginEstimation() {
    if (!this.viewModel.showEstimateButton() || !this.showTrafficEstimation) {
      return;
    }

    if (this.activityLogger) {
      this.activityLogger.signal('clicked get perf estimation', 'search bid');
    }

    const bid = this.viewModel.SearchBid();
    const keywords = this.getKeywordsCb();

    this.viewModel.errors([]);

    if (_.isFinite(bid) && this.validate() && _.isFinite(this.budget)) {
      if (_.isEmpty(this.adgroupName) || _.isEmpty(keywords)) {
        this.viewModel.errors.add([i18n.get('Estimate_SearchTraffic_Error')]);
        return;
      }

      const adGroupObj = {
        Name: this.adgroupName,
        Keywords: keywords,
      };

      getTrafficEstimation({
        locations: this.locations,
        adGroup: adGroupObj,
        bid: decimalNumber.fromFloatToString(bid),
        budget: decimalNumber.fromFloatToString(this.budget),
        languages: this.languages,
      }, {
        onNotAllSupported: (supportedCount, totalCount) => {
          this.viewModel.infoMessage(i18n.get('TarfficEstimation_PartiallyNonSupported')
            .replace('{0}', supportedCount)
            .replace('{1}', totalCount));
        },
        onSuccess: (data) => {
          this.viewModel.updateEstimations(data);
        },
        onRequestError: () => {
          this.viewModel.showEstError();
        },
        onNonSupported: () => {
          // do nothing if none of the locations is supported
        },
        onServiceNotSupported: this.viewModel.showEstError.bind(this.viewModel),
      }, {
        spinner: this.$('.input-group'),
      });
    }
  }

  clearEstimation() {
    this.viewModel.errors([]);
    this.viewModel.infoMessage('');
    this.viewModel.showEstimation(false);
  }

  validate() {
    // if it is autobidding, no need to validate bid.
    // sometimes, the bid for autobidding will have 4 decimal places, like 1.1234.
    const isValid =  this.viewModel.isAutoBidding() || (this.viewModel.validate() && _.isEmpty(this.viewModel.searchBidErrorMessage()));

    if (!isValid) {
      instrumentation.logMessage(
        [constants.LOGCATEGORY.SUBSTRATE],
        constants.LOGLEVEL.INFO,
        'search bid',
        'search bid is not valid',
      );
    }

    return isValid;
  }

  getValues() {
    return this.viewModel.disableSearchBid() ? {} : this.viewModel.toObject();
  }

  updateSuggestions(data) {
    if (_.isEmpty(data.value)) {
      return;
    }

    const est = _.property('AdGroupEstimatedTraffic')(_.first(data.value));
    const suggestedBid = this.viewModel.roundToTwo(_.property('SuggestedBid')(_.first(data.value)));

    this.viewModel.suggestedBidRequestId(data.suggestedBidRequestId);
    if (!_.isEmpty(est)) {
      this.viewModel.SuggestedClicks(est.Clicks);
      this.viewModel.SuggestedImpressions(est.Impressions);
    }
    this.viewModel.suggestedBidNew(suggestedBid);
    if (!this.viewModel.isBidChanged() && suggestedBid > 0) {
      this.viewModel.SearchBid(suggestedBid);
      this.beginEstimationDebounced();
    }
    if (!this.viewModel.showEstimation()) {
      this.viewModel.showEstimation(true);
    }
  }

  fetchBidSuggestionNewApi() {
    if (!this.viewModel.showEstimateButton() || !this.showTrafficEstimation) {
      return;
    }

    const keywords = this.getKeywordsCb();

    if (!_.isEmpty(keywords) && !_.isEmpty(this.adgroupName) ) {
      const adGroupObj = {
        Name: this.adgroupName,
        Keywords: keywords,
      };

      getTrafficEstimation({
        locations: this.locations,
        adGroup: adGroupObj,
        budget: decimalNumber.fromFloatToString(this.budget),
        languages: this.languages,
      }, {
        onNotAllSupported: (supportedCount, totalCount) => {
          this.viewModel.infoMessage(i18n.get('TarfficEstimation_PartiallyNonSupported')
            .replace('{0}', supportedCount)
            .replace('{1}', totalCount));
        },
        onSuccess: (res) => {
          this.updateSuggestions(res);
        },
        onRequestError: _.noop,
        onServiceNotSupported: _.noop,
        onNonSupported: _.noop,
      }, {
        spinner: this.$('.input-group'),
      },
      bidSugggestionNewApi,
      );
    }
  }

  fetchBidSuggestion() {
    this.isNKW = false;
    const callTimestamp = +new Date();

    if (this.bidStatusEnabled && this.viewModel.showEstimateButton()) {
      const keywords = this.getKeywordsCb();

      if (keywords.length) {
        getBidSuggestion({
          locations: this.locations,
          languages: this.languages,
          adGroup: {
            Keywords: keywords,
          },
        }, {
          onSuccess: (res, timestamp) => {
            if (
              res &&
              res.value &&
              res.value.length &&
              !_.isNull(res.value[0])
            ) {
              this.updateSuggestedBid(
                Math.min(
                  bidRange.CeilingValue,
                  Math.ceil(res.value[0].Amount * 100) / 100,
                ),
                timestamp,
                true,
              );
            } else {
              this.updateSuggestedBid(0, timestamp);
            }
          },
          onRequestError: (useless, timestamp) => {
            this.updateSuggestedBid(0, timestamp);
          },
          onServiceNotSupported: (useless, timestamp) => {
            this.updateSuggestedBid(0, timestamp);
          },
          onNonSupported: (useless, timestamp) => {
            this.updateSuggestedBid(0, timestamp);
          },
        }, {},
        callTimestamp);
      }
    } else {
      this.updateSuggestedBid(0, callTimestamp);
    }
  }

  updateSuggestedBid(suggestedBid, timestamp, isNKW = false) {
    if (timestamp > this.updatedTimestamp) {
      this.isNKW = isNKW;
      this.updatedTimestamp = timestamp;
      this.viewModel.suggestedBid(suggestedBid);
      this.viewModel.suggestedBidNew(suggestedBid);
    }
  }

  /**
   * Called when location targetings or language are changed, scenarios: new signup campaign creation page; adgroup creation workflow
   * @param {boolean} showEstimation show traffic estimation button or not
   * @param {array} locations current level location targetings
   * @param {array} languages current level language targetings
   * @returns {void}
   */
  onLanguageLocationChanged(showEstimation, locations, languages) {
    this.clearEstimation();
    this.viewModel.showEstimateButton(showEstimation);

    //used for traffic estimation and bid suggestion
    this.locations = locations;
    this.languages = languages;

    this.fetchBidSuggestionNewApiDebounced();
  }

  updateBidLandscapeAvailability(bidLandscapeAvailable) {
    this.viewModel.bidLandscapeAvailable(bidLandscapeAvailable);
  }

  updateAdGroupName(newName) {
    this.adgroupName = newName;
  }

  updateBudgetAmount(newAmount) {
    this.budget = newAmount;
  }

  onKeywordsEditingFinished() {
    this.fetchBidSuggestionNewApiDebounced();
    this.beginEstimationDebounced();
  }

  remove() {
    if (!_.isUndefined(this.statusSubscription)) {
      this.statusSubscription.dispose();
    }
    super.remove();
  }
}
